<template lang="pug">
    Tabs.purchase-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .purchases-table(v-else)
                include purchased-items.pug
</template>

<i18n>
{
    "de": {
        "Edit Article": "Artikel bearbeiten",
        "Article could not be saved": "Artikel konnte nicht gespeichert werden",
        "Article saved successfully!": "Artikel erfolgreich gespeichert!",
        "Quantity": "Anzahl",
        "Available": "Verfügbar",
        "Sold": "Verkauft",
        "Re-Ordered": "Im Zulauf",
        "Stock": "Lager",
        "shipped": "versendet",
        "canceled": "storniert",
        "reserved": "reserviert",
        "missing": "fehlend",
        "re-ordered": "im Zulauf",
        "packed": "versandfertig",
        "To": "An",
        "With": "Mit",
        "By": "Von",
        "Point Of Sale": "Kasse",
        "shipping package slip": "Paketschein anzeigen",
        "Add article to cart": "Artikel in den Warenkorb legen",
        "no selectable properties": "keine auswählbare Attribute",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Packing slip": "Paketschein",
        "Packing slip PDF": "Paketschein PDF",
        "Preview could not be rendered": "Vorschau konnte nicht gerendered werden",
        "Missing PDF": "PDF konnte nicht gefunden werden",
        "Send packing list via email": "Packliste per Email versenden",
        "Inform selected warehouses by email": "Ausgewählte Läger per Email informieren",
        "View PDF": "PDF anzeigen",
        "From": "Von",
        "To": "An",
        "Cc": "Cc",
        "Bcc": "Bcc",
        "Subject": "Betreff",
        "Preview": "Vorschau",
        "Print": "Drucken",
        "Download": "Herunterladen",
        "Email preview": "Email vorschau",
        "Send now": "Jetzt versenden",
        "new": "Neu",
        "Point Of Sale Purchases": "Kassenverkäufe",
        "Web Shop Purchases": "Webshopverkäufe",
        "Internal Purchases": "Interne Aufträge"
    }
}
</i18n>

<script>
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useShopPurchasedItemStore } from '@/stores'

import Tabs from '@/extensions/shop/views/Partials/SalesTabs'
import Articles from '@/extensions/shop/views/Purchase/Form/Articles'

export default {
    name: 'PurchasedItemList',
    extends: Articles,
    data() {
        return {
            scope: 'ex',
            key: 'shop_purchased_item',

            error: false,
            // loading: true,
            disable: {
                showFilters: false,
            },
            sortables: [
                'id',
                'name',
                'sku',
                'description',
                'purchaser',
                'created_at',
            ]
        }
    },
    components: {
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        sort() {
            let articlesPaginated = _.cloneDeep(this.articlesPaginated.variables);
            let order, direction;
            if (articlesPaginated.order !== undefined && articlesPaginated.order !== '') order = articlesPaginated.order;
            else order = 'id';

            if (articlesPaginated.direction !== undefined && articlesPaginated.direction !== '') direction = articlesPaginated.direction;
            else direction = 'desc';

            return { field: order, direction };
        },
        includeWebShopPurchases() {
            const key = 'ex:shop_purchased_item:include_web_shop_purchases';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'true'
            return value === 'true'
        },
        includeInternals() {
            const key = 'ex:shop_purchased_item:include_internals';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'false'
            return value === 'true'
        },
        includePointOfSalePurchases() {
            const key = 'ex:shop_purchased_item:include_point_of_sale_purchases';
            const misc = _.get(this.user, 'settings.misc') || [];
            const setting = misc.find(item => item && item.key === key)

            const value = _.get(setting, 'value') || 'false'
            return value === 'true'
        },

        user() {
            return useAuthStore().user;
        },
        setupStore() {
            return useSetupStore();
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        purchasedItemStore() {
            return useShopPurchasedItemStore(pinia);
        },
        form() {
            return this.purchasedItemStore.form;
        },
        options() {
            return this.purchasedItemStore.options;
        },
        loading() {
            return this.purchasedItemStore.loading;
        },
        ui() {
            return this.purchasedItemStore.ui;
        },
        articlesPaginated() {
            // needs to be named "articlesPaginated" for the mixin
            return this.purchasedItemStore.purchasedItemsPaginated;
        },
    },
    methods: {
        getCurrency(item) {
            return _.get(item.purchase, 'currency')
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.updateLoading(true)
                return
            }

            this.updateLoading(true)
            this.refetch()
        },
        updateLoading(value) {
            this.updateLoadingState(value)
            this.pagination.loading = value
        },

        toggleWebShopPurchasesFilter() {
            const key = 'ex:shop_purchased_item:include_web_shop_purchases';
            const value = !this.includeWebShopPurchases

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        toggleInternalsFilter() {
            const key = 'ex:shop_purchased_item:include_internals';
            const value = !this.includeInternals

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        togglePointOfSalePurchasesFilter() {
            const key = 'ex:shop_purchased_item:include_point_of_sale_purchases';
            const value = !this.includePointOfSalePurchases

            this.updateLoading(true)
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch)
            // this.$nextTick(this.refetch);
        },
        updateLoadingState(value) {
            this.purchasedItemStore.updateLoading(value);
        },
        defineItemsPerPage(value) {
            this.purchasedItemStore.defineItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.purchasedItemStore.defineCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.purchasedItemStore.defineActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.purchasedItemStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.purchasedItemStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.purchasedItemStore.defineSorting(payload);
        },
        fetchArticlesPaginated(payload) {
            return this.purchasedItemStore.fetchPurchasedItemsPaginated(payload);
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        },
    },
    mounted() {
        this.initialize()
    },
}
</script>
